import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import Money from './types/Money';
import Quantity from './types/Quantity';
import merge from 'lodash/merge';

export default class ClaimResponseItemDetail extends BackboneElement {
    static __className = 'ClaimResponseItemDetail';

    __objectStructure = {
        productOrService: CodeableConcept,
        modifier: [CodeableConcept],
        quantity: Quantity,
        unitPrice: Money,
    };

    constructor(constructJson, className = 'ClaimResponseItem') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
